<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="mod-sys__position">
      <el-form label-position="top"
               :inline="true"
               :model="dataForm">
        <el-row>
          <!-- 组织类型 -->
          <el-col :span="5">
            <el-form-item :label="$t('position.orgType')">
              <el-select v-model="dataForm.orgType"
                         :placeholder="$t('position.orgType')"
                         clearable>
                <el-option v-for="(item,index) in newOrgType"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 职位代码 -->
          <el-col :span="5">
            <el-form-item :label="$t('position.positionCode')">
              <el-input v-model="dataForm.positionCode"
                        :placeholder="$t('position.positionCode')"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 职位中文名称 -->
          <el-col :span="5">
            <el-form-item :label="$t('position.positionNameCn')">
              <el-input v-model="dataForm.positionName"
                        :placeholder="$t('position.positionNameCn')"
                        maxlength="20"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 职位团队分类 -->
            <el-form-item :label="$t('position.positionGroupType')">
              <el-select v-model="dataForm.positionGroupType"
                         :placeholder="$t('position.positionGroupType')"
                         clearable>
                <el-option v-for="(item,index) in positionGroupArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-col :span="24">
              <el-button style="margin-bottom: 7px"
                         class="M-search"
                         type="primary"
                         @click="query()">{{ $t('query') }}</el-button>
            </el-col>
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         @click="reset()">{{ $t('reset') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <el-form label-position="top"
               :inline="true"
               v-show="isShow">
        <el-row>
          <el-col :span="5">
            <!-- 状态 -->
            <el-form-item :label="$t('position.status')">
              <el-select v-model="dataForm.status"
                         :placeholder="$t('position.status')"
                         clearable>
                <el-option v-for="(item,index) in statusArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 职位品牌 -->
            <el-form-item :label="$t('position.brandCode')">
              <el-select v-model="dataForm.brandCode"
                         :placeholder="$t('position.brandCode')"
                         clearable>
                <el-option v-for="(item,index) in brandArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 业务属性 -->
          <el-col :span="5">
            <el-form-item :label="$t('common.tagChecked')">
              <el-select v-model="dataForm.labelId"
                         :placeholder="$t('common.tagChecked')"
                         clearable
                         remote
                         filterable
                         reserve-keyword
                         :remote-method="queryTag">
                <el-option v-for="(item,index) in tagCheckedArr"
                           :key="index"
                           :label="item.labelName"
                           :value="item.labelId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 单店单岗 -->
            <el-form-item :label="$t('position.singlePosition')">
              <el-select v-model="dataForm.singlePosition"
                         :placeholder="$t('position.singlePosition')"
                         clearable>
                <el-option v-for="(item,index) in confirmStateArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <!-- 是否TA审批 -->
            <el-form-item :label="$t('position.taApprovalFlag')">
              <el-select v-model="dataForm.taApprovalFlag"
                         :placeholder="$t('position.taApprovalFlag')"
                         clearable>
                <el-option v-for="(item,index) in confirmStateArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 可设为兼职 -->
            <el-form-item :label="$t('position.partTimeJobFlag')">
              <el-select v-model="dataForm.partTimeJobFlag"
                         :placeholder="$t('position.partTimeJobFlag')"
                         clearable>
                <el-option v-for="(item,index) in confirmStateArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <ToggleDiv @toggle="toggle"></ToggleDiv>
      <div class="search">
        <!-- 新增按钮 -->
        <el-button type="primary"
                   v-if="$hasPermission('AUTH000100')"
                   @click="addUpdate()">{{ $t('add') }}</el-button>
        <el-button plain
                   class="el-button-columnBtn"
                   @click="exportHandle()">{{ $t('export') }}</el-button>
      </div>
      <!-- 职位表格 -->
      <el-table v-loading="dataListLoading"
                :data="dataList"
                border
                style="width: 100%;">
        <!-- 职位代码 -->
        <el-table-column prop="positionCode"
                         :label="$t('position.positionCode')"
                         header-align="center"></el-table-column>
        <!-- 岗位名称 -->
        <el-table-column prop="positionName"
                         :label="$t('position.positionNameCn')"
                         width="150"
                         show-overflow-tooltip
                         header-align="center"></el-table-column>
        <!-- 职位团队分类 -->
        <el-table-column prop="positionGroupType"
                         :label="$t('position.positionGroupType')"
                         width="110"
                         header-align="center"
                         :formatter="getGroupName"></el-table-column>
        <!-- 组织类型 -->
        <el-table-column prop="orgType"
                         :label="$t('position.orgType')"
                         width="110"
                         header-align="center"
                         :formatter="getOrgName"></el-table-column>
        <!-- 品牌 -->
        <el-table-column prop="brandCode"
                         :label="$t('position.brandCode')"
                         header-align="center"
                         align="center"
                         :formatter="brandCodeFormatter"></el-table-column>
        <!-- 单店单岗 -->
        <el-table-column prop="singlePosition"
                         :label="$t('position.singlePosition')"
                         header-align="center"
                         align="center"
                         :formatter="singlePositionFormatter"></el-table-column>
        <!-- 是否TA审批 -->
        <el-table-column prop="taApprovalFlag"
                         :label="$t('position.taApprovalFlag')"
                         header-align="center"
                         align="center"
                         :formatter="taApprovalFlagFormatter"></el-table-column>
        <!-- 可设为兼职职位 -->
        <el-table-column prop="partTimeJobFlag"
                         :label="$t('position.partTimeJobFlag')"
                         header-align="center"
                         align="center"
                         :formatter="partTimeJobFlagFormatter"></el-table-column>
        <!-- 状态 -->
        <el-table-column prop="status"
                         :label="$t('position.status')"
                         header-align="center"
                         align="center"
                         :formatter="getStatusName"></el-table-column>
        <!-- 操作 -->
        <el-table-column fixed="right"
                         align="center"
                         width="120"
                         :label="$t('handle')">
          <template slot-scope="scope">
            <!-- 查看 -->
            <span class="el-dropdown-link"
                  v-if="$hasPermission('AUTH000102')"
                  @click="gotoView('view', scope.row.positionId)">{{ $t('view') }}</span>
            <el-divider direction="vertical"
                        v-if="$hasPermission('AUTH000102')"></el-divider>
            <el-dropdown trigger="click"
                         placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item @click.native="gotoView('view', scope.row.positionId)">{{ $t('view') }}</el-dropdown-item> -->
                <el-dropdown-item v-if="$hasPermission('AUTH000101')"
                                  @click.native="gotoView('update', scope.row.positionId)">{{ $t('update') }}</el-dropdown-item>
                <!-- <el-dropdown-item @click.native="gotoView('delete', scope.row)">{{ $t('delete') }}</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import ToggleDiv from '@/components/toggle-div'
import Vue from 'vue'
// import debounce from 'lodash/debounce'
export default {
  mixins: [mixinViewModule],
  data() {
    let _this = this
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/commposition/list',
        getDataListIsPage: true,
        deleteURL: '/sys/commposition/delete',
        deleteIsBatch: true
      },
      orgArr: _this.enums['orgType'], // 组织类型
      brandArr: _this.enums['brandCode'], // 职位品牌
      positionGroupArr: _this.enums['group'], // 职位团队分类
      statusArr: _this.enums['status'], // 状态
      confirmStateArr: _this.enums['confirmState'], // 是否
      tagCheckedArr: [], // 标签下拉列表
      newOrgType: [],
      dataList: [],
      dataListLoading: false,
      isShow: false,
      dataForm: {}
    }
  },
  mounted() {
    this.newOrgType = JSON.parse(JSON.stringify(this.orgArr))
    if (this.newOrgType.length === 6) {
      // this.newOrgType.splice(3, 2)
      this.newOrgType.splice(4, 1)
    }
  },
  components: {
    ToggleDiv
  },
  methods: {
    // 新增，修改
    addUpdate(row) {
      this.$router.push({
        name: 'sys-position-add-or-update'
      })
      this.$eventHub.$emit(this.GLOBAL.ACTIVATED_POSITION, 'activated')
    },
    // 操作列下拉选项
    gotoView(type, id) {
      if (type === 'view') {
        this.$router.push({
          name: 'sys-position-view',
          query: {
            positionId: id
          }
        })
      } else if (type === 'update') {
        this.$router.push({
          name: 'sys-position-add-or-update',
          query: {
            positionId: id
          }
        })
        this.$eventHub.$emit(this.GLOBAL.ACTIVATED_POSITION, 'activated')
      } else if (type === 'delete') {
        // this.deletePosition(id)
      }
    },
    // 搜索标签
    queryTag(queryString) {
      this.$request.get('/sys/commlabel/positionList',
        {
          bussinessTypeId: 2,
          labelName: queryString,
          limit: 10
        }
      ).then((res, total, code, data) => {
        this.tagCheckedArr = res
      }).catch(() => { })
    },
    // 删除
    // deletePosition: debounce(
    //   function (row) {
    //     // deletePosition (row) {
    //     this.$confirm(this.$t('prompt.position'), this.$t('prompt.title'), {
    //       confirmButtonText: this.$t('confirm'),
    //       cancelButtonText: this.$t('cancel'),
    //       type: 'warning'
    //     }).then(() => {
    //       this.$request.delete(
    //         this.mixinViewModuleOptions.deleteURL,
    //         {
    //           positionId: row.positionId
    //         }
    //       ).then((res) => {
    //         this.$message({
    //           message: this.$t('prompt.success'),
    //           type: 'success',
    //           duration: 500,
    //           onClose: () => {
    //             this.query()
    //           }
    //         })
    //       }).catch(() => { })
    //     }).catch(() => { })
    //   }, 5000, { leading: true, trailing: false }
    // ),
    // 获取table职位团队分类
    getGroupName(row) {
      return Vue.filter('coverEnum')(row.positionGroupType, 'positionGroupType')
    },
    // 获取table组织类型
    getOrgName(row) {
      return Vue.filter('coverEnum')(row.orgType, 'orgType')
    },
    // 获取table状态
    getStatusName(row) {
      return Vue.filter('coverEnum')(row.status, 'status')
    },
    brandCodeFormatter(row) {
      return Vue.filter('coverEnum')(row.brandCode, 'brandCode')
    },
    singlePositionFormatter(row) {
      return Vue.filter('coverEnum')(row.singlePosition, 'confirmState')
    },
    taApprovalFlagFormatter(row) {
      return Vue.filter('coverEnum')(row.taApprovalFlag, 'confirmState')
    },
    partTimeJobFlagFormatter(row) {
      return Vue.filter('coverEnum')(row.partTimeJobFlag, 'confirmState')
    },
    toggle(val) {
      this.isShow = val
    },
    // 导出
    exportHandle() {
      this.page = 1
      // download 参数 url, params, 报表名
      this.$request.download('/sys/commposition/export', this.$t('position.organizationExport'),
        {
          ...this.dataForm,
          page: this.page,
          limit: 5000
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  margin-bottom: 10px;
}
</style>
